<template>
    <div class="v-alert doc-main-container" :style="{ top: top+'px', left: left+'px', width: width+'px', height: height+'px', marginLeft: '0px' }">
        <div class="grab" @mousedown="startMove($event)"></div>
        <header><p style="margin-left: 30px;">Documentation</p><div class="x" @click="exit()"></div></header>
        <div class="doc-box" :class="{ 'hide-menu': hideMenu }">
            <div class="doc-menu">
                <div v-for="(section,i) in doc.sections" :key="i">
                    <p class="doc-main" :class="{ selected: section.selected }" @click="getSection(section)">{{ section.title }}</p>
                    <p class="doc-sub" :class="{ selected: sub.selected }" v-for="sub in section.subs" @click="getSubSection(section,sub)">{{ sub.title }}</p>
                </div>
            </div>
            <div class="doc-content" :style="{  height: (height - 38)+ 'px' }">
                <div class="mini-ham" @click="hideMenu =! hideMenu">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="scroller ql-editor" v-html="content">

                </div>
                <div class="size-box" @mousedown="startSize($event)"></div>
            </div>
        </div>
    </div>
</template>

<script>

import WebSoc from '@/utils/WebSoc.js'

export default {
    props: ['search'],
    data () {
        return {
            hideMenu: false,
            moving: false,
            sizing: false,
            startX: 0,
            doc: {},
            startY: 0,
            top: 100,
            left: 100,
            width: 1100,
            height: 500,
            content: '',
            quill_id: ''
        }
    },
    beforeDestroy () {
        this.stopListen();
    },
    created () {
        var width = window.innerWidth;
        this.left = ( ( width - this.width ) / 2 );
    },
    mounted () {
        WebSoc.SEND('search',{ DB: 'docs', find: { title: 'memberstar', live: true }},docs => {
            this.doc = docs[0];
            this.clearAllSections();
            this.getSection(this.doc.sections[0]);
            this.startListen();
        })
    },
    methods: {
        startListen() {
            document.body.addEventListener('mousemove',this.move);
            document.body.addEventListener('mouseup',this.stop);
            document.body.addEventListener('mouseleave',this.stop);
        },
        stopListen () {
            document.body.removeEventListener('mousemove',this.move);
            document.body.removeEventListener('mouseup',this.stop);
            document.body.removeEventListener('mouseleave',this.stop);
        },
        startMove ( e ) {
            this.moving = true;
            this.startX = e.clientX;
            this.startY = e.clientY;
        },
        move ( e ) {
            var { moving, sizing } = this;
            if ( !moving && !sizing ) return;
            e.preventDefault();
            var { startX, startY } = this;
            var { clientX, clientY } = e;
            if ( moving ) {
                this.top = this.top - ( startY - clientY );
                this.left = this.left - ( startX - clientX );
            } else {
                var width = this.width - ( startX - clientX )
                width > 420 && ( this.width = width );
                var height = this.height - ( startY - clientY );
                height > 276 && ( this.height = height );
            }
            this.startX = clientX;
            this.startY = clientY;
        },
        stop () {
            this.moving = false;
            this.sizing = false;
        },
        startSize ( e ) {
            this.sizing = true;
            this.startX = e.clientX;
            this.startY = e.clientY;
        },
        exit () {
            this.$emit('exit');
        },
        clearAllSections () {
            this.doc.sections.forEach(section => {
                section.selected = false;
                section.subs.forEach(sub => sub.selected = false);
            });
        },
        getSubSection ( section, sub ) {
            this.clearAllSections();
            sub.selected = true;
            this.$forceUpdate()
            if ( this.quill_id != section.quill_id ) {
                WebSoc.SEND({ t: 'xGet', data: { DB: 'quill', _id: section.quill_id }},quill => {
                    this.quill_id = quill._id;
                    this.content = quill.docHTML;
                    scrollIntoView(this.$el,sub.id);
                })                
            } else {
                scrollIntoView(this.$el,sub.id);
            }

            function scrollIntoView($el,id) {
                var element = $el.querySelector('#'+id);
                element && element.scrollIntoView(true);
            }
        },
        getSection ( section ) {
            this.clearAllSections();
            section.selected = true;
            this.$forceUpdate();
            this.$el.querySelector('.doc-content > .scroller').scrollTop = 0;
            if ( this.quill_id == section.quill_id ) return;
            WebSoc.SEND('get',{ DB: 'quill', _id: section.quill_id },quill => {
                this.quill_id = quill._id;
                this.content = quill.docHTML;
            })
        }
    }
}

</script>

<style lang="scss">

.doc-main-container {
    min-width: 170px;
    .grab {
        left: -28px;
        top: -28px;
    }
    .doc-box {
        display: grid;
        grid-template-columns: 190px minmax(0, 1fr);
        float: left;
        width: 100%;
        height: calc(100% - 38px);
        
        &.hide-menu {
            grid-template-columns: minmax(0, 1fr);
            .doc-menu {
                display: none;
            }
            .mini-ham {
                transform: translateX(20px);
                background-color: rgba(140, 149, 163,0.3);
            }            
        }
        .doc-menu {
            position: relative;
            background-color: rgba(140, 149, 163,0.3);
            overflow: hidden;
            p { margin: 10px; }
            .doc-main { font-weight: bold; }
            .doc-sub { margin-left: 30px; }
            .doc-main,.doc-sub {
                &.selected {
                    text-decoration: underline;
                }
            }
        }
        .doc-content {
            height: 100%;
            width: 100%;
            position: relative;
            > div {
                margin: 0px 25px;
                overflow-x: hidden;
                overflow-y: scroll;
                float: left;
                width: calc(100% - 50px);
                height: 100%;
                > *:first-child { margin-top: 25px; }
                > *:last-child { margin-bottom: 25px; }
            }
            .mini-ham {
                width: 20px;
                height: 20px;
                position: absolute;
                top: 0px;
                left: -20px;
                margin: 0px;
                > div {
                    width: 18px;
                    height: 2px;
                    background-color: white;
                    float: left;
                    margin: 2px 1px
                }
            }
            .size-box {
                width: 30px;
                height: 30px;
                position: absolute;
                left: auto;
                top: auto;
                right: -20px;
                bottom: -20px;
                background-size: 30px 30px;
                background-position: 10px 10px;
                margin: 0px;
            }
        }
    }
}

</style>